import { useState } from "react";

function useToggle(initialValue = false) {
  const [value, setValue] = useState(initialValue);

  const toggle = () => {
    setValue((prevValue) => !prevValue);
  };

  const setToggle = (newValue) => {
    setValue(newValue);
  };

  return { value, toggle, setToggle };
}

export default useToggle;
